
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { DiscountsTable } from "@/components/discounts/DiscountsTable";
import { CreateDiscountDialog } from "@/components/discounts/CreateDiscountDialog";
import { useDiscounts } from "@/hooks/useDiscounts";
import { DeleteDiscountDialog } from "@/components/discounts/DeleteDiscountDialog";

const Discounts = () => {
  const {
    discounts,
    loading,
    discountToDelete,
    setDiscountToDelete,
    handleDelete,
    fetchDiscounts,
    searchQuery,
    setSearchQuery,
    page,
    setPage,
    totalPages,
  } = useDiscounts();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12 flex justify-between items-start">
              <div>
                <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                  Discounts
                </h1>
                <p className="text-xl text-gray-600 mt-2">
                  Manage discounts for schools and products
                </p>
              </div>
              <CreateDiscountDialog onDiscountCreated={fetchDiscounts} />
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6">
              <DiscountsTable
                discounts={discounts}
                loading={loading}
                onDelete={setDiscountToDelete}
                onDiscountUpdated={fetchDiscounts}
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
                page={page}
                totalPages={totalPages}
                onPageChange={setPage}
              />
            </div>
          </div>
        </div>
      </div>

      <DeleteDiscountDialog
        discount={discountToDelete}
        isOpen={!!discountToDelete}
        onClose={() => setDiscountToDelete(null)}
        onConfirm={() => discountToDelete && handleDelete(discountToDelete.id)}
      />
    </SidebarProvider>
  );
};

export default Discounts;
